import React from "react";
import { useState, useEffect, useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer,toast } from "react-toastify";
import Select from 'react-select'
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import {  IconButton, Modal, Box, Dialog, DialogActions, DialogContent, DialogTitle,TextField, Grid, Card, CardContent, CardHeader } from '@mui/material';
import Table from 'react-bootstrap/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { saveApprovalMatrix } from "assets/globalAPI/apiGlobal";
import { Pagination } from "react-bootstrap";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import { saveApprovalApprovalMatrixVendor } from "assets/globalAPI/apiGlobal";
import { fetchVendorMatrix } from "assets/globalAPI/apiGlobal";
import { fetchMaterialMatrix } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { fetchCustomerMatrix } from "assets/globalAPI/apiGlobal";
import { saveApprovalMatrixCustomer } from "assets/globalAPI/apiGlobal";
import { fetchMaterialBelongsTo } from "assets/globalAPI/apiGlobal";
import { fetchMaterialTypes } from "assets/globalAPI/apiGlobal";


const customStyles = {
    control: (provided) => ({
      ...provided,
      width: 80,
      minHeight: "30px",
      fontSize: "0.9rem"
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "0.85rem",
      zIndex  : 9999
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "0.85rem",
      padding: 8
    })
  };

const ApprovalMatrix=()=>{
const toastId = React.useRef(null);
const navigate= useNavigate();
    const [selectedTab, setSelectedTab]= useState('material')
    const [belongsTo, setBelongsTo]= useState('');
    const [materialType,setMaterialType]= useState('');
    const [userEmail,setUserEmail]= useState('');
    const [currentIndex, setCurrentIndex]= useState(0);
    const [users, setUsers]= useState([]);
    const [vendorMatrixData, setVendorMatrixdata]= useState([]);
    const [customerMatrixData, setCustomerMatrixdata]= useState([]);
    const [materialMatrixData, setMaterialMatrixdata]= useState([]);
    const [open, setOpen]= useState(false);
    const [open2, setOpen2]= useState(false);
    const [open3, setOpen3]= useState(false);
    const [userSearch,setUserSearch]= useState("");
    const typingTimeoutRef = useRef(null);
          const latestSearchRef = useRef("");
    const [isActive, setIsActive]= useState(false);
    const [fetchedMaterial, setFetchedMatrix]= useState(false);
    const [desigSelected, setDesigSelected]= useState(false);
     const [matTypes,setMatTypes]= useState([])
      const [allBelongs,setAllbelongs]= useState([])
    const [matrix, setMatrix] = useState([
      {user_name:"", user_id: "", user_email: "", dept: 1 }
    ]);
      const [matrix2, setMatrix2] = useState([
        {user_type: "" ,user_id: "", user_email: "", dept: 1 , user_name:""}
      ]);

      const [matrix3, setMatrix3] = useState([
        {user_type: "", userid: "", user_email: "" ,approval_mode:"", approval_id: "", designation: "", dept: 1}
      ]);
      const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage]= useState(1);
      const [totalPages, setTotalPages]= useState(1);
      const [selectedType, setSelectedType]= useState('');
      const [selectedUserType, setSelectedUserType]= useState('');
      const [selectedDesig, setSelectedDesig]= useState('');
      const [approvalMode,setApprovalMode]= useState('')
      const handlePageChange = (page) => {
        setCurrentPage(page);
      };

      const fetchAllUsers=async()=>{
        setIsActive(true)
        const body={
            page: latestSearchRef.current==""? currentPage: 1,
            search: latestSearchRef.current
        }
        try{
            const response= await getAllUsers(body);
            const res= response.data;
            console.log("response is>> ", res)
            if(res.status){
              setIsActive(false)
                console.log("all users fetched>> ", res);
                setUsers(res.data);
                setTotalPages(res.totalPages)
            }else{
              setIsActive(false)
                console.log("could not fetch users>> ", res);
              
                setTotalPages(1)
                setUsers([])
            }
        }catch(err){
          setIsActive(false)
            console.log("the error is bringing users>> ", err)
            
        }
      }

      const handleSearchChange = (e) => {
        const value = e.target.value;
        setUserSearch(value);
        latestSearchRef.current = value;
    
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    
       
    typingTimeoutRef.current = setTimeout(() => {
      fetchAllUsers(); // Inside this function, access latest value from latestSearchRef.current
    }, 2000);
  }


      const fetchMatrixVendor=async(appMode)=>{
        setIsActive(true);
        const body={
          approval_mode: appMode
        }

        try{
            const response= await fetchVendorMatrix(body);
            const res= response.data;
            console.log("response is>> ", res)
            if(res.status){
                console.log("all matrix of vendor fetched>> ", res);
                setVendorMatrixdata(res.data);
                const mappedData = res.data.map(item => ({
                  user_type: item.user_type || "", 
                  user_id: item.userid || "",
                  user_email: item.user_email || "",
                  dept: item.dept || 1,
                  user_name:item.user_type==="initiator"? "": item.userApprovalName || "" 
                }));
                setMatrix2(mappedData);
                setIsActive(false)
            }else{
                console.log("could not fetch vendor matrix>> ", res);
                setVendorMatrixdata(res.data);
                setIsActive(false)
            }
        }catch(err){
            console.log("the error is bringing vendor matrix>> ", err)
            setIsActive(false)
            if(err.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session has expired",{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return;
            }
        }
      }


      const fetchMatrixCustomer=async(appMode)=>{
        setIsActive(true);
        const body={
          approval_mode: appMode
        }

        try{
            const response= await fetchCustomerMatrix(body);
            const res= response.data;
            console.log("response is>> ", res)
            if(res.status){
                console.log("all matrix of customer fetched>> ", res);
                setCustomerMatrixdata(res.data);
                const mappedData = res.data.map(item => ({
                  user_type: item.user_type,
                  userid: item.userid,
                  user_email: item.user_email,
                  approval_mode: item.approval_mode || "", 
                  approval_id: item.approval_id || "",
                  designation: item.designation || "",
                  dept: item.dept || 1,
                }));
                setMatrix3(mappedData);
                setIsActive(false)
            }else{
                console.log("could not fetch customer matrix>> ", res);
                setCustomerMatrixdata(res.data);
                setIsActive(false)
            }
        }catch(err){
            console.log("the error is bringing customer matrix>> ", err)
            setIsActive(false)
            if(err.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session has expired",{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return;
            }
        }
      }

      const fetchMatrixMaterial = async(Obj) => {
        console.log("matrix called for material")
        setIsActive(true)
        const body={
          material_type: Obj.materialType,
          belongs_to: Obj.belongsTo,
          approval_mode: Obj.approvalMode
        }
        console.log("here is body>>> ", body)
        try{
            const response= await fetchMaterialMatrix(body);
            const res= response.data;
            console.log("response is>> ", res)
            if(res.status){
                console.log("all matrix of material fetched>> ", res);
                setMaterialMatrixdata(res.data);
                const mappedData = res.data.map(item => ({ 
                  user_id: item.userid || "",
                  user_email: item.user_email || "",
                  dept: item.dept || 1,
                  user_name: item.userApprovalName || "" 
                }));
                console.log("mappedData--->",mappedData);
                setMatrix(mappedData)
                setIsActive(false)
            }else{
                console.log("could not fetch material matrix>> ", res);
                setMaterialMatrixdata(res.data);
                setIsActive(false)
              
            }
        }catch(err){
            console.log("the error is bringing material matrix>> ", err)
            setIsActive(false)
            
        }
      }

      const fetchAllMaterialTypes=async()=>{
        setIsActive(true)
            try{
              const response= await fetchMaterialTypes();
              const res= response.data;
              if(res.status){
                setMatTypes(res.data);
                setIsActive(false)
                console.log("mat types fetched>> ", res.data);
              }else{
                setIsActive(false)
                console.log("could not bring mat types>> ", res)
              }
            }catch(error){
              console.log("error bringing mat types>> ", error);
              setIsActive(false)
              if(error.response?.status==403){
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.error("Your Session has expired",{
                    className:"small-toast"
                  })
                }
                setTimeout(()=>{
                  navigate("/")
                  localStorage.clear();
                },2000)
                return;
              }
            }
          }
          
          const fetchAllMaterialBelongsTo=async(type)=>{
            const body={
              "material_type":type
            }
            try{
              const response= await fetchMaterialBelongsTo(body);
              const res= response.data;
              if(res.status){
                
      const mapped = res.data?.map(item => ({
        value: item.belongs_to,
        label: item.belongs_to
      }));
                setAllbelongs(mapped);
                console.log("belongs to fetched>> ", res.data);
              }else{
                console.log("could not bring mat belongs>> ", res)
              }
            }catch(error){
              console.log("error bringing mat belongs>> ", error);
              if(error.response?.status==403){
                if(!toast.isActive(toastId.current)){
                  toastId.current= toast.error("Your Session has expired",{
                    className:"small-toast"
                  })
                }
                setTimeout(()=>{
                  navigate("/")
                  localStorage.clear();
                },2000)
                return;
              }
            }
          }

      useEffect(()=>{
        fetchAllUsers()
        fetchMatrixVendor();
        fetchAllMaterialTypes();
      },[currentPage])

    const userOptions = [
        { value: "sukrit.chakraborty@arodek.com", label: "Sukrit Chakraborty", id: 1},
        { value: "pritam.manna@arodek.com", label: "Pritam Manna", id: 5},
        { value: "kartick.dutta@arodek.com", label: "Kartick Dutta", id: 133}
      ];
      const handleUserChange = (index, selectedOption) => {
        console.log("here is the selected user>> ", selectedOption)
        const updatedMatrix = [...matrix];
        updatedMatrix[index].user_id = selectedOption.id;
        updatedMatrix[index].user_email = selectedOption.email;
        updatedMatrix[index].user_name = selectedOption.name;
        console.log("upadted used is>> ", updatedMatrix)
        setMatrix(updatedMatrix);
        setOpen(false);
      };

      const handleUserChange2 = (index, selectedOption) => {
        const updatedMatrix = [...matrix2];
        updatedMatrix[index].user_type= selectedType
        updatedMatrix[index].user_id = selectedOption.id;
        updatedMatrix[index].user_email = selectedOption.email;
        updatedMatrix[index].user_name = selectedOption.name;
        setMatrix2(updatedMatrix);
        setOpen2(false);
      };


      const handleUserChange3 = (index, selectedOption) => {
        const updatedMatrix = [...matrix3];
        updatedMatrix[index].user_type= selectedUserType
        updatedMatrix[index].userid = selectedOption.id;
        updatedMatrix[index].user_email = selectedOption.email;
        setMatrix3(updatedMatrix);
        setOpen3(false);
      };

      const addRow = () => {
        const newDept = matrix.length + 1;
        setMatrix([...matrix, { user_id: "", user_email: "", dept: newDept }]);
      };

      
      const deleteRow = () => {
        if (matrix.length > 1) {
          setMatrix(matrix.slice(0, -1));
        }
      };
      const addRow2 = () => {
        const newDept = matrix2.length + 1;
        setMatrix2([...matrix2, { user_id: "", user_email: "", dept: newDept }]);
      };

      const addRow3 = () => {
        const newDept = matrix3.length + 1;
        setMatrix3([...matrix3, { designation: "", dept: newDept }]);
      };
      const deleteRow2 = () => {
        if (matrix2.length > 1) {
          setMatrix2(matrix2.slice(0, -1));
        }
      };

      const deleteRow3 = () => {
        if (matrix3.length > 1) {
          setMatrix3(matrix3.slice(0, -1));
        }
      };
      

      const handleOpenDialog=(index, type)=>{
        setCurrentIndex(index);
       
        fetchAllUsers(currentPage)
        if(type==="material"){
          setOpen(true);

        }else if(type==="vendor"){
          setOpen2(true)
        }else if(type==="customer"){
          setOpen3(true);
        }
      }

      const handleSubmit = async() => {
        setIsActive(true)
        const jsonData = {
          belongs_to: belongsTo,
          material_type: materialType,
          approval_mode: approvalMode,
          matrix: matrix
        };
        console.log("api body ready>> ", jsonData);

        try{
            const response= await saveApprovalMatrix(jsonData);
            const res= response.data;
            if(res.status){
    if(!toast.isActive(toastId.current)){
                    toastId.current= toast.success(res.message,{
                    className:"small-toast"
                    })
                }

                console.log("Matrix set successfully>> ", res);
                setIsActive(false)
                setFetchedMatrix(false)
                setApprovalMode("")
                setMatrix([
                  {user_name:"", user_id: "", user_email: "", dept: 1 }
                ])
                setBelongsTo('');
                setMaterialType('');
                setApprovalMode('')
            }else{
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(res.message,{
                    className:"small-toast"
                    })
                }

                console.log("Matrix setting error>> ", res);
            }
        }catch(error){
          if(error.response?.status==403){
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.error(error.response.data.message,{
                className:"small-toast"
              })
            }
            setTimeout(()=>{
              navigate("/")
              localStorage.clear();
            },2000)
            return;
          }
            if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.message,{
                className:"small-toast"
                })
            }
            console.log("Approval matrix error>> ", error)
        }
      };

      const handleSubmit2 = async() => {
        setIsActive(true)
        const jsonData = {
          approval_mode:approvalMode,
          matrix: matrix2
        };
        console.log("api body ready>> ", jsonData);

        try{
            const response= await saveApprovalApprovalMatrixVendor(jsonData);
            const res= response.data;
            if(res.status){
    if(!toast.isActive(toastId.current)){
                    toastId.current= toast.success(res.message,{
                    className:"small-toast"
                    })
                }

                console.log("Matrix set successfully>> ", res);
                setIsActive(false)
                setApprovalMode("")
                fetchMatrixVendor();
            }else{
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(res.message,{
                    className:"small-toast"
                    })
                }
                setIsActive(false)

                console.log("Matrix setting error>> ", res);
            }
        }catch(error){
            if(error.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.response.data.message,{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return
            }
            if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.message,{
                className:"small-toast"
                })
            }
            setIsActive(false)
            console.log("Approval matrix error>> ", error)
        }
      };

      const belongsToMapping = {
        "ASSET": "ASSET",
        "STORE": "STORE",
        "RGP": "RGP",
        "RM": "RM",
        "PM": "PM",
        "SFG": "SFG",
        "FG": "FG",
        "BROKEN_SCRAP": "SCRAP",
        "FREE_GOODS": "FREE-GOODS",
        "NON_VALUATED": "NON-VALUED",  
  
      };


      const handleSubmit3 = async() => {
        setIsActive(true)
        const jsonData = {
          approval_mode:approvalMode,
          matrix: matrix3
        };
        console.log("api body ready>> ", jsonData);

        try{
            const response= await saveApprovalMatrixCustomer(jsonData);
            const res= response.data;
            if(res.status){
    if(!toast.isActive(toastId.current)){
                    toastId.current= toast.success(res.message,{
                    className:"small-toast"
                    })
                }

                console.log("Matrix set successfully>> ", res);
                setIsActive(false)
                setApprovalMode("")
                fetchMatrixCustomer();
            }else{
                if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error(res.message,{
                    className:"small-toast"
                    })
                }
                setIsActive(false)

                console.log("Matrix setting error>> ", res);
            }
        }catch(error){
            if(error.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.response.data.message,{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
              return
            }
            if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(error.message,{
                className:"small-toast"
                })
            }
            setIsActive(false)
            console.log("Approval matrix error>> ", error)
        }
      };

    //   <Select
    //   menuPlacement="auto"
    //   menuPortalTarget={document.body} 
    //     options={[
    //       { value: "IT", label: "IT" },
    //       { value: "Project", label: "Project" },
    //       { value: "Others", label: "Others" }
    //     ]}
    //     onChange={(e)=>setBelongsTo(e.value)}
    //     placeholder="Select"
    //     styles={{
    //       ...customStyles,
    //       control: (provided) => ({
    //         ...provided,
    //         width: 180,
    //         minHeight: "30px",
    //         fontSize: "14px"
    //       })
    //     }}
    //   />

    // <Select
    // menuPlacement="auto"
    // menuPortalTarget={document.body} 
    //   options={[
    //     { value: "ASSET", label: "ASSET" },
    //     { value: "STORE", label: "STORE" },
    //     { value: "RGP", label: "RGP" },
    //     { value: "RM", label: "RM" },
    //     { value: "SM", label: "SM" },
    //     { value: "SFG", label: "SFG" },
    //     { value: "FG", label: "FG" },
    //   ]}
    //   onChange={(e)=>setMaterialType(e.value)}
    //   placeholder="Select"
    //   styles={{
    //     ...customStyles,
    //     control: (provided) => ({
    //       ...provided,
    //       width: 180,
    //       zIndex: 9999,
    //       minHeight: "40px",
    //       fontSize: "14px"
    //     })
    //   }}
    // />

    return (
        <DashboardLayout>
        <DashboardNavbar/>

        <ToastContainer/>
        <SimpleBackdrop openLoader={isActive}/>
        <Tabs
          defaultActiveKey="profile"
          id="uncontrolled-tab-example"
          className="mb-3"
          activeKey={selectedTab}
          onSelect={(k)=>{
            
            setSelectedTab(k)}}
        >
          <Tab eventKey="material" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Material</span>}>
          <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
  <CardHeader title="Material Approval Creation" />
  <CardContent>
  <Grid container spacing={2} alignItems="center">
  {/* New Section Above SoftSelects */}
  
    <Grid item xs={12} md={4} sm={6}>
      <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
        Approval Mode:
      </SoftTypography>
      <Select
      menuPlacement="auto"
      menuPortalTarget={document.body}
      value={[{value: approvalMode, label: approvalMode}]}
      options={[
        { value: "create", label: "Create" }
      ]}
      placeholder="Select Option"
      onChange={(e)=>{setApprovalMode(e.value)
        if(belongsTo=="") {
          // fetchMatrixMaterial({materialType, belongsTo, approvalMode: e.value});
          // setFetchedMatrix(true);
          return
        }else{
          fetchMatrixMaterial({materialType, belongsTo, approvalMode: e.value});
        }
      }}
      styles={{
        ...customStyles,
        control: (provided) => ({
          ...provided,
          width: '100%',
          minHeight: "30px",
          fontSize: "14px"
        })
      }}
    />
    </Grid>
    
 
  
  <Grid item xs={12} sm={6} md={4}>
    <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
      Material Type:
    </SoftTypography>
    <Select
      menuPlacement="auto"
      menuPortalTarget={document.body} 
      value={[{value: materialType, label: materialType}]}
      options={[
        { value: "ASSET", label: "ASSET" },
        { value: "STORE", label: "STORE" },
        { value: "BROKEN_SCRAP", label: "SCRAP" },
        { value: "NON_VALUATED", label: "NON-VALUED" },
        { value: "FREE_GOODS", label: "FREE-GOODS" },
        { value: "RGP", label: "RGP" },
        { value: "RM", label: "RM" },
        { value: "PM", label: "PM" },
        { value: "SFG", label: "SFG" },
        { value: "FG", label: "FG" },
      ]}
      onChange={(e)=>{
        setMaterialType(e.value);
        fetchAllMaterialBelongsTo(belongsToMapping[e.value])
        if(belongsTo=="") {
          // fetchMatrixMaterial({materialType: e.value, belongsTo, approvalMode});
          // setFetchedMatrix(true);
          return;
        }else{
          fetchMatrixMaterial({materialType: e.value, belongsTo, approvalMode});
        }
      }}
      placeholder="Select"
      styles={{
        ...customStyles,
        control: (provided) => ({
          ...provided,
          width: '100%',
          zIndex: 9999,
          minHeight: "40px",
          fontSize: "14px"
        })
      }}
    />
  </Grid>
  {/* Belongs To */}
  <Grid item xs={12} sm={6} md={4}>
    <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
      Belongs To:
    </SoftTypography>
    <Select
      menuPlacement="auto"
      menuPortalTarget={document.body} 
      value={[{value: belongsTo, label: belongsTo}]}
      options={allBelongs}
      onChange={(e)=>{
        setBelongsTo(e.value);
        if(materialType!=="" && approvalMode!=="") {
          fetchMatrixMaterial({materialType, belongsTo: e.value, approvalMode});
          setFetchedMatrix(true);
        }
      }}
      placeholder="Select"
      styles={{
        ...customStyles,
        control: (provided) => ({
          ...provided,
          width: '100%',
          minHeight: "30px",
          fontSize: "14px"
        })
      }}
    />
  </Grid>

  {/* Material Type */}
  
</Grid>

    
    {/* User Selection Grid */}
    
<>

    <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>

      {matrix.map((row, index) => (
        <Grid container item spacing={2} key={index} alignItems="center">
          <Grid item xs={12} sm={4}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Select User:
        </SoftTypography>
            {/* <Select
             menuPlacement="auto"
             menuPortalTarget={document.body} 
              options={userOptions}
              placeholder="Select"
              onChange={(selectedOption) => handleUserChange(index, selectedOption)}
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  zIndex: 9999,
                  minHeight: "40px",
                  fontSize: "14px"
                })
              }}
            /> */}
            <TextField value={row.user_name} sx={{cursor: 'pointer'}} onClick={() => handleOpenDialog(index, "material")} variant="outlined" fullWidth readOnly/>
          </Grid>
          <Grid item xs={12} sm={4}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Email:
        </SoftTypography>
            <TextField value={row.user_email} variant="outlined" fullWidth disabled />
          </Grid>
          <Grid item xs={12} sm={4}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Approval level:
        </SoftTypography>
            <TextField value={row.dept} variant="outlined" fullWidth disabled />
          </Grid>
        </Grid>
      ))}
    </Grid>
</>

   
    
    {/* Buttons */}
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item>
        <SoftButton variant="contained" color="info" onClick={addRow} disabled={ materialType===""}>Add Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton variant="contained" color="error" onClick={deleteRow} disabled={matrix.length === 1 || belongsTo==="" || materialType===""}>Delete Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton disabled={ materialType===""} variant="contained" color="success" onClick={handleSubmit}>Submit</SoftButton>
      </Grid>
    </Grid>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
    <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
        <input
                          type="text"
                          placeholder="Search using Name or Code"
                          value={userSearch}
                          onChange={(e) => handleSearchChange(e)}
                          style={{
                            width: "100%",
                            padding: "5px",
                            marginBottom: "10px",
                            fontSize: "12px",
                          }}
                        />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
              <tbody>
                                                       
                                                       <>
                                                       {users && users.map((user) => (
                                                         <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                           <td>{user.name}</td>
                                                           <td>{user.email}</td>
                                                           <td>{user.userid}</td>
                                                           <td>
                                                             <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange(currentIndex,user)}>Select</SoftButton>
                                                           </td>
                                                         </tr>
                                                       ))}
                                                       </>
                                                       {users?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                   </tbody>
            </Table>
          </>

          {/* <TablePagination
            component="div"
            count={totalPages * rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
          /> */}
          <Pagination className="mt-3">
                  <Pagination.Prev 
                    disabled={currentPage === 1} 
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[...Array(totalPages).keys()].map((page) => (
                    <Pagination.Item 
                      key={page + 1} 
                      active={page + 1 === currentPage} 
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next 
                    disabled={currentPage === totalPages} 
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                </Pagination>
        </DialogContent>
      </Dialog>
  </CardContent>
</Card>
          </Tab>
          <Tab eventKey="customer" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Customer</span>}>
          <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
  <CardHeader title="Customer Approval Creation" />
  <CardContent>
    
    
    {/* User Selection Grid */}
    <Grid container spacing={3} alignItems="center" sx={{ mt: 2 }}>
    <Grid item xs={12} md={4} >
    <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
      Approval Mode:
    </SoftTypography>
    <Select
      menuPlacement="auto"
      menuPortalTarget={document.body}
      value={[{value: approvalMode, label: approvalMode}]}
      options={[
        { value: "create", label: "Create" },
        { value: "update", label: "Update" }
      ]}
      
      placeholder="Select Option"
      onChange={(e)=>{

        setApprovalMode(e.value)
        fetchMatrixCustomer(e.value)
      }}
      styles={{
        ...customStyles,
        control: (provided) => ({
          ...provided,
          width: '100%',
          minHeight: "30px",
          fontSize: "14px"
        })
      }}
    />
  </Grid>
      {matrix3.map((row, index) => (
        <Grid container item spacing={2} key={index} alignItems="center">
          <Grid item xs={12} sm={2}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Type:
        </SoftTypography>
            <Select
             menuPlacement="auto"
             menuPortalTarget={document.body} 
              options={[
                { value: "Designation", label: "Designation" },
                { value: "User", label: "User" },
              ]}
              value={[{value: row.user_type || selectedUserType, label: row.user_type || selectedUserType}]}
              onChange={(e)=>{
                // setSelectedUserType(e.value)
                if(e.value==="Designation" ){
                  const updatedMatrix = [...matrix3];
                  updatedMatrix[index].user_type = e.value;
                  updatedMatrix[index].userid = 0;
                  updatedMatrix[index].user_email = "";
                  setMatrix3(updatedMatrix)
                }else{
                  // const updatedMatrix = [...matrix3];
                  // updatedMatrix[index].user_type = e.value;
                  // setMatrix3(updatedMatrix)
                  setSelectedUserType(e.value)
                  handleOpenDialog(index, "customer")
                }
              }}
              placeholder="Select"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  zIndex: 9999,
                  minHeight: "40px",
                  fontSize: "14px"
                })
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User ID:
        </SoftTypography>
            <TextField value={row.userid} variant="outlined" fullWidth  disabled />
          </Grid>

          <Grid item xs={12} sm={2}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Email:
        </SoftTypography>
            <TextField value={row.user_email} variant="outlined" fullWidth disabled />
          </Grid>

           <Grid item xs={12} sm={2}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
         Designation:
        </SoftTypography>
            <Select
             menuPlacement="auto"
             menuPortalTarget={document.body} 
              options={[
                { value: "ASM", label: "ASM" },
                { value: "Infra Officer", label: "Infra Officer" },
                { value: "RSM", label: "RSM" },
                { value: "Trade Marketing Manager", label: "Trade Marketing Manager" },
                { value: "ZSM", label: "ZSM" },
                { value: "NSM", label: "NSM" },
                { value: "MDM", label: "MDM" },
                { value: "Sales", label: "Sales" },
                    { value: "Accounts", label: "Accounts" },
                    { value: "BIZOM", label: "BIZOM" },
                    { value: "Supply Chain Management", label: "Supply Chain Management" },
                    { value: "MIS", label: "MIS" },
                    { value: "Others", label: "Others" },
              ]}
              value={[{value: row.designation || selectedDesig, label: row.designation || selectedDesig}]}
              onChange={(e)=>{
                setSelectedDesig(e.value)
                const updatedMatrix = [...matrix3];
        updatedMatrix[index].designation= e.value
        updatedMatrix[index].dept = row.dept;
        setMatrix3(updatedMatrix);
              }}
              placeholder="Select"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  zIndex: 9999,
                  minHeight: "40px",
                  fontSize: "14px"
                })
              }}
            />
          </Grid>
          {/* <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Select User:
        </SoftTypography>
            <TextField disabled={selectedType===""} value={row.user_name} sx={{cursor: 'pointer'}} onClick={() =>{ 
              if(selectedType===""){
                return;
              }else{

                handleOpenDialog(index, "vendor")
              }
              }} variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Email:
        </SoftTypography>
            <TextField value={row.user_email} variant="outlined" fullWidth disabled />
          </Grid> */}
          <Grid item xs={12} sm={2}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Approval level:
        </SoftTypography>
            <TextField value={row.dept} variant="outlined" fullWidth disabled />
          </Grid>
        </Grid>
      ))}
    </Grid>
    
    {/* Buttons */}
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item>
        <SoftButton variant="contained" color="info" onClick={addRow3}>Add Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton variant="contained" color="error" onClick={deleteRow3} disabled={matrix3.length === 1}>Delete Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton variant="contained" color="success" onClick={handleSubmit3}>Submit</SoftButton>
      </Grid>
    </Grid>



  </CardContent>
</Card>
          </Tab>
          <Tab eventKey="vendor" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Vendor</span>}>
          <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>
  <CardHeader title="Vendor Approval Creation" />
  <CardContent>
    
    
    {/* User Selection Grid */}
    <Grid container spacing={3} alignItems="center" sx={{ mt: 2 }}>
    <Grid item xs={12} md={4}>
    <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
      Approval Mode:
    </SoftTypography>
    <Select
      menuPlacement="auto"
      menuPortalTarget={document.body}
      value={[{value: approvalMode, label: approvalMode}]}
      options={[
        { value: "create", label: "Create" },
        { value: "update", label: "Update" }
      ]}
      
      placeholder="Select Option"
      onChange={(e)=>{

        setApprovalMode(e.value)
        fetchMatrixVendor(e.value)
      }}
      styles={{
        ...customStyles,
        control: (provided) => ({
          ...provided,
          width: '100%',
          minHeight: "30px",
          fontSize: "14px"
        })
      }}
    />
  </Grid>
      {matrix2.map((row, index) => (
        <Grid container item spacing={2} key={index} alignItems="center">
           <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Type:
        </SoftTypography>
            <Select
             menuPlacement="auto"
             menuPortalTarget={document.body} 
              options={[
                { value: "initiator", label: "Initiator" },
                { value: "user", label: "User" },
              ]}
              value={[{value: row.user_type || selectedType, label: row.user_type || selectedType}]}
              onChange={(e)=>{
                if(e.value==="initiator" ){
                  setSelectedType(e.value)
                  const updatedMatrix = [...matrix2];
                  updatedMatrix[index].user_type = e.value;
                  updatedMatrix[index].user_email = "";
                  updatedMatrix[index].user_name= "";
                  setMatrix2(updatedMatrix)
                }else{
                  console.log("matrix after selection>> ", matrix2)
                  setSelectedType(e.value)
                  const updatedMatrix = [...matrix2];
                  updatedMatrix[index].user_type = e.value;
                  setMatrix2(updatedMatrix)
                }
              }}
              placeholder="Select"
              styles={{
                ...customStyles,
                control: (provided) => ({
                  ...provided,
                  width: "100%",
                  zIndex: 9999,
                  minHeight: "40px",
                  fontSize: "14px"
                })
              }}
            />
          </Grid>
          <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Select User:
        </SoftTypography>
            <TextField disabled={selectedType==="" || selectedType=="initiator"} value={row.user_name} sx={{cursor: 'pointer'}} onClick={() =>{ 
              if(selectedType==="" || selectedType=="initiator"){
                return;
              }else{

                handleOpenDialog(index, "vendor")
              }
              }} variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          User Email:
        </SoftTypography>
            <TextField value={row.user_email} variant="outlined" fullWidth disabled />
          </Grid>
          <Grid item xs={10} sm={3}>
          <SoftTypography component="label" variant="h6" fontWeight="bold" textTransform="capitalize">
          Approval level:
        </SoftTypography>
            <TextField value={row.dept} variant="outlined" fullWidth disabled />
          </Grid>
        </Grid>
      ))}
    </Grid>
    
    {/* Buttons */}
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item>
        <SoftButton variant="contained" color="info" onClick={addRow2}>Add Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton variant="contained" color="error" onClick={deleteRow2} disabled={matrix2.length === 1}>Delete Row</SoftButton>
      </Grid>
      <Grid item>
        <SoftButton variant="contained" color="success" onClick={handleSubmit2}>Submit</SoftButton>
      </Grid>
    </Grid>



    <Dialog open={open2} onClose={() => setOpen2(false)} maxWidth="md" fullWidth>
    <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>

        <DialogContent>
           <input
                          type="text"
                          placeholder="Search using Name or Code"
                          value={userSearch}
                          onChange={(e) => handleSearchChange(e)}
                          style={{
                            width: "100%",
                            padding: "5px",
                            marginBottom: "10px",
                            fontSize: "12px",
                          }}
                        />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
                <tbody>
                                                       
                                                       <>
                                                       {users && users.map((user) => (
                                                         <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                           <td>{user.name}</td>
                                                           <td>{user.email}</td>
                                                           <td>{user.userid}</td>
                                                           <td>
                                                             <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange2(currentIndex,user)}>Select</SoftButton>
                                                           </td>
                                                         </tr>
                                                       ))}
                                                       </>
                                                       {users?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                   </tbody>
            </Table>
          </>

          {/* <TablePagination
            component="div"
            count={totalPages * rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
          /> */}
          <Pagination className="mt-3">
                  <Pagination.Prev 
                    disabled={currentPage === 1} 
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[...Array(totalPages).keys()].map((page) => (
                    <Pagination.Item 
                      key={page + 1} 
                      active={page + 1 === currentPage} 
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next 
                    disabled={currentPage === totalPages} 
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                </Pagination>
        </DialogContent>
      </Dialog>

      <Dialog open={open3} onClose={() => setOpen3(false)} maxWidth="md" fullWidth>
        <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
        <input
                          type="text"
                          placeholder="Search using Name or Code"
                          value={userSearch}
                          onChange={(e) => handleSearchChange(e)}
                          style={{
                            width: "100%",
                            padding: "5px",
                            marginBottom: "10px",
                            fontSize: "12px",
                          }}
                        />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
             <tbody>
                                                       
                                                           <>
                                                           {users && users.map((user) => (
                                                             <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                               <td>{user.name}</td>
                                                               <td>{user.email}</td>
                                                               <td>{user.userid}</td>
                                                               <td>
                                                                 <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange3(currentIndex,user)}>Select</SoftButton>
                                                               </td>
                                                             </tr>
                                                           ))}
                                                           </>
                                                           {users?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                       </tbody>
            </Table>
          </>

          {/* <TablePagination
            component="div"
            count={totalPages * rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
          /> */}
          <Pagination className="mt-3">
                  <Pagination.Prev 
                    disabled={currentPage === 1} 
                    onClick={() => handlePageChange(currentPage - 1)}
                  />
                  {[...Array(totalPages).keys()].map((page) => (
                    <Pagination.Item 
                      key={page + 1} 
                      active={page + 1 === currentPage} 
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next 
                    disabled={currentPage === totalPages} 
                    onClick={() => handlePageChange(currentPage + 1)}
                  />
                </Pagination>
        </DialogContent>
      </Dialog>
  </CardContent>
</Card>
          </Tab>
        </Tabs>
        </DashboardLayout>
      );
}

export default ApprovalMatrix;